module.exports = __webpack_public_path__ + "img/icon-startup-light-white.9517e8c4.svg";